<div class="" [formGroup]="notificationsConfig">
    <p-autocomplete
        type="email"
        formControlName="emails"
        multiple
        class="mb-4"
        id="key"
        [typeahead]="false"
        [addOnBlur]="true"
        [addOnTab]="true"
        separator=","
        placeholder=""
        fluid
    />
    <!-- (onAdd)="onChipChanged($event)"
    (onUnselect)="onChipChanged($event)"
    (keydown.enter)="onChipChanged($event)" -->
    <!-- <mat-form-field class="w-100">
      <mat-label>Emails</mat-label>
      <mat-chip-grid #chipGrid formControlName="emails">
        @for (chip of chipValues; track chip) {
          <mat-chip-row [value]="chip" (removed)="chipInputRemove(chip)">
            {{chip}}
            <button matChipRemove><mat-icon>cancel</mat-icon></button>
          </mat-chip-row>
        }
      </mat-chip-grid>
      <input type="email" email
        [formControl]="inputControl"
        placeholder="Nuevo email..."
        [matChipInputFor]="chipGrid"
        (matChipInputTokenEnd)="add($event)"
        />
    </mat-form-field> -->
      
    <ul>
        <li class="mb-4" formGroupName="channels">
            <span class="font-bold mb-2">{{'projects.notificationsConfig.channels.title' | translate}}:</span>
            <div class="flex gap-4">
                <div class="flex items-center gap-2">
                    <p-checkbox formControlName="app" inputId="channels-app" [binary]="true"/>
                    <label for="channels-app" class="text-sm">{{'projects.notificationsConfig.channels.app' | translate}}</label>
                </div>
                <div class="flex items-center gap-2">
                    <p-checkbox formControlName="email" inputId="channels-email" [binary]="true"/>
                    <label for="channels-email" class="text-sm">{{'projects.notificationsConfig.channels.email' | translate}}</label>
                </div>
            </div>
        </li>
    </ul>
</div>

<span class="font-bold mb-2">{{'projects.notificationsConfig.conditions.title' | translate}}:</span>
<ul class="mb-4">
    @for (condition of project.notificationsConfig?.variables; track condition) {
        <li>{{"variables." + condition | translate}}: {{project.notificationsConfig?.requirements[condition]=='eval'?this.translateService.instant('projects.notificationsConfig.conditions.eval'):(project.notificationsConfig?.requirements[condition].operation + project.notificationsConfig?.requirements[condition].value)}}</li>
    }
</ul>

<div class="w-full text-center">
    <button pButton (click)="updateProject(notificationsConfig)">{{ ('button.save') | translate}}</button>
</div>